import { render, staticRenderFns } from "./water-sewage.vue?vue&type=template&id=b2d32c0a"
import script from "./water-sewage.vue?vue&type=script&lang=js"
export * from "./water-sewage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports